export default __webpack_public_path__ + "static/media/dog_4.74575cc5.png";